import '../../../../../../../node_modules/mediaelement/build/mediaelement-and-player';

// initialize media element player
export function initMediaElement() {
	jQuery('video, audio').mediaelementplayer({
		pluginPath: window.pathInfo ? pathInfo.base + pathInfo.js : 'js/',
		iconSprite: ''
	});
}
